import { render, staticRenderFns } from "./content-dialog.vue?vue&type=template&id=f1f89052"
import script from "./content-dialog.vue?vue&type=script&lang=js"
export * from "./content-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports